<template>
    <div class="clearfix ssv-summary__wrap">
        <div class="box box--white box--white-large ssv-summry-price-box">
            <ssv-order-price-calculation/>
        </div>
        <div class="box box--white box--white-large ssv-summry-voucher-box" v-if="courseDate.canUseVouchers">
            <button class="button button--link" v-on:click="displayVoucher = true" v-if="!voucher">Zadat slevový kupon
            </button>
            <div class="ssv-summry-voucher-box__form">
                <ssv-order-voucher-container v-if="displayVoucher"/>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import SsvOrderPriceCalculation from './PriceCalculation';
    import SsvOrderVoucherContainer from '../voucher/VoucherContainer';

    export default {
        name: 'SsvOrderPriceContainer',
        data() {
            return {
                displayVoucher: false,
            }
        },
        components: {
            SsvOrderVoucherContainer,
            SsvOrderPriceCalculation
        },
        computed: {
            ...mapGetters('ssvOrder', ['courseDate', 'voucher']),
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/price/PriceContainer.vue